import React from "react";
import { Offcanvas, Badge, Card, Row, Col, ProgressBar } from "react-bootstrap";
import { FaEdit } from "react-icons/fa";

const CorierDetail = ({ Show, Hide, Title, rowData, corierColumns }) => {
  return (
    <Offcanvas show={Show} onHide={Hide} placement="end" size="lg">
      <Offcanvas.Header closeButton>
        <Offcanvas.Title>{Title}</Offcanvas.Title>
      </Offcanvas.Header>
      <Offcanvas.Body>
        {/* Corier Header */}
        <div className="d-flex justify-content-between align-items-start mb-3">
          <div>
            <h5 style={{ fontSize: 14 }} className="mb-1">{rowData?.row?.CORIERNAME}</h5>
            <span className="text-muted font-monospace small">{rowData?.row?.CORIERID}</span>
          </div>
          <Badge
            bg="success-subtle"
            style={{ fontSize: 10 }}
            className={`br3 text-success border border-success px-2 text-capitalize mx-2`}
          >
            Active
          </Badge>
        </div>

        {/* Corier Details */}
        <Card className="mb-3">
          <Card.Body className="p-3">
            <Row>
              {corierColumns?.map((item, index) => (
              <Col className="mb-2" key={index} xs={6}>
                <div className="text-muted small">{item?.columnLabel}</div>
                <small style={{fontSize: 12}}>{rowData?.row?.[item?.columnName] || "_"}</small>
              </Col>
              ))}
            </Row>
          </Card.Body>
        </Card>
      </Offcanvas.Body>
    </Offcanvas>
  );
};

export default CorierDetail;